module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/102-balearic-islands-e82171c56d34d34395ac0d9f616b6f58.svg";